export const fromEntries = (xs: [string | number | symbol, any][]) => {
  // @ts-ignore
  if (Object.fromEntries) {
    // @ts-ignore
    return Object.fromEntries(xs);
  } else {
    return xs.reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});
  }
};
